import { CamelCaseKeys } from '@uplift/types';
import { restClient } from '../client';
import { Appointment, PaymentTypeName } from '../resources';
import { ClaimBalance, ServiceItemPaymentStatus, Payment } from './admin';


export enum PatientServiceItemType {
  appointment = 'appointment',
  medicalNote = 'medical_note',
}

export type PatientServiceItemCashPayment = {
  type?: PaymentTypeName.cash;
  payment?: Payment;
  status: ServiceItemPaymentStatus;
};

export type PatientServiceItemInsurancePayment = {
  type?: PaymentTypeName.insurance;
  payment?: Payment;
  insuranceName?: string;
  secondaryInsuranceName?: string;
  claim: ClaimBalance | null;
  status: ServiceItemPaymentStatus;
};

export type PatientServiceItemPayment = PatientServiceItemCashPayment | PatientServiceItemInsurancePayment;

export enum PatientServiceItemStatus {
  outstanding = 'outstanding',
  processing = 'processing',
  completed = 'completed',
}

export type PatientAppointmentServiceItem = CamelCaseKeys<{
  id: string;
  status: PatientServiceItemStatus;
  service_type: PatientServiceItemType.appointment;
  service_date: string;
  provider: {
    id: string;
    name: string;
  };

  payment?: PatientServiceItemPayment;
  service: {
    appointment: Appointment;
    client_did_not_show: boolean;
    primary_cpt_code?: string;
    cpt_codes: string[];
  };
}>;

export type PatientMedicalNoteServiceItem = CamelCaseKeys<{
  id: string;
  status: PatientServiceItemStatus;
  service_type: PatientServiceItemType.medicalNote;
  service_date: string;
  provider: {
    id: string;
    name: string;
  };

  payment?: PatientServiceItemPayment;
  service: {
    cpt_codes: string[];
  };
}>;

export type PatientServiceItem = PatientAppointmentServiceItem | PatientMedicalNoteServiceItem;


export const getPatientServiceItems = (patientId: string) => restClient.request<{
  data: Partial<Record<PatientServiceItemStatus, PatientServiceItem[]>>;
}>(`/api/v1/patient/${patientId}/payments`);


export type PatientSessionHistoryResponseItems = PatientServiceItem[];
